var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h2", [_vm._v(_vm._s(_vm.plant))]),
      _c("light-timeline", {
        attrs: { items: _vm.items },
        scopedSlots: _vm._u([
          {
            key: "tag",
            fn: function ({ item }) {
              return [_vm._v(" " + _vm._s(_vm.getTimeLabel(item.week)) + " ")]
            },
          },
          {
            key: "content",
            fn: function ({ item }) {
              return [
                _c("TimelineCell", {
                  attrs: { data: item },
                  on: {
                    "to-save": function ($event) {
                      return _vm.$emit("to-save")
                    },
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }